import { useCallback, useState } from 'react';

export const useFilters = <T extends Record<string, any>>(initialState: T) => {
  const [filters, setFilters] = useState<T>(initialState);

  const handleFilterChange = useCallback(
    <K extends keyof T>(key: K) =>
      (value: T[K]) => {
        setFilters((prev) => ({ ...prev, [key]: value }));
      },
    [setFilters],
  );

  return { filters, handleFilterChange };
};
